<template>
  <el-card>
    <template #header>
      <content-header />
    </template>
    <el-row
      type="flex"
      justify="center"
    >
      <lz-form
        ref="form"
        :get-data="getData"
        :submit="onSubmit"
        :errors.sync="errors"
        :form.sync="form"
        :edit-mode="editMode"
        :rules="rules"
      >
        <el-form-item
          label="账号"
          required
          prop="account"
        >
          <el-input v-model="form.account" />
        </el-form-item>
        <el-form-item
          label="姓名"
          required
          prop="name"
        >
          <el-input v-model="form.name" />
        </el-form-item>
        <el-form-item
          label="头像"
          prop="avatar"
        >
          <file-picker
            v-model="form.avatar"
            ext="jpg,gif,png,jpeg"
          />
        </el-form-item>
        <el-form-item
          label="工号"
          required
          prop="job_number"
        >
          <el-input
            v-model="form.job_number"
            onkeyup="this.value=this.value.replace(/[^\d.]/g,'');"
            maxlength="6"
            show-word-limit
          />
        </el-form-item>
        <el-form-item
          label="手机号"
          required
          prop="phone"
        >
          <el-input v-model="form.phone" />
        </el-form-item>
        <el-form-item
          label="账号状态"
          required
          prop="status"
        >
          <el-switch
            v-model="form.status"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="正常"
            inactive-text="禁用"
          />
        </el-form-item>
        <el-form-item
          label="是否可登录运维端"
          required
          prop="is_login_app"
        >
          <el-switch
            v-model="form.is_login_app"
            active-color="#13ce66"
            inactive-color="#ff4949"
            active-text="正常"
            inactive-text="禁用"
          />
        </el-form-item>
        <el-form-item
          label="密码"
          :required="!editMode"
          prop="password"
        >
          <el-input
            v-model="form.password"
            type="password"
            autocomplete="new-password"
          />
        </el-form-item>
        <el-form-item
          label="确认密码"
          :required="!editMode"
          prop="password_confirmation"
        >
          <el-input
            v-model="form.password_confirmation"
            type="password"
            autocomplete="new-password"
          />
        </el-form-item>
        <el-form-item
          label="角色"
          prop="roles"
        >
          <el-select
            v-model="form.roles"
            multiple
            placeholder="选择角色"
            :multiple-limit="1"
            filterable
            clearable
          >
            <el-option
              v-for="i of roles"
              :key="i.id"
              :label="i.name"
              :value="i.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="区域"
          required
          prop="areas"
        >
          <el-select
            multiple
            filterable
            clearable
            v-model="form.areas"
            placeholder="请选择"
          >
            <el-option
              v-for="item in areas"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>
        <el-form-item
          label="商户"
          prop="merchant_id"
          v-show="merchantsShow"
        >
          <el-select
            filterable
            clearable
            v-model="form.merchant_id"
            placeholder="请选择"
          >
            <el-option
              v-for="item in merchants"
              :key="item.id"
              :label="item.name"
              :value="item.id"
            />
          </el-select>
        </el-form-item>

        <!-- <el-form-item label="权限" prop="permissions">
          <el-select
            v-model="form.permissions"
            multiple
            :multiple-limit="1"
            placeholder="选择权限"
            filterable
            clearable
          >
            <el-option
              v-for="i of permissions"
              :key="i.id"
              :label="i.name"
              :value="i.id"
            />
          </el-select>
        </el-form-item> -->
      </lz-form>
    </el-row>
  </el-card>
</template>

<script>
import LzForm from "@c/LzForm";
import {
  editAdminUser,
  storeAdminUser,
  updateAdminUser
} from "@/api/admin-users";
import { getAdminRoles } from "@/api/admin-roles";
import { getAreas } from "@/api/area";
import { getAdminPerms } from "@/api/admin-perms";
import FormHelper from "@c/LzForm/FormHelper";
import FilePicker from "@c/FilePicker";
import _get from "lodash/get";
import store from "@/store";
import { ROLE_ADMIN } from "@/libs/constants";
import { getAdminUsersMerchant } from "@/api/admin-merchant";

export default {
  name: "Form",
  components: {
    FilePicker,
    LzForm
  },
  mixins: [FormHelper],
  data() {
    var checkPhone = (rule, value, callback) => {
      if (!value) {
        return callback(new Error("手机号不能为空"));
      } else {
        const reg = /^1[3|4|5|7|8][0-9]\d{8}$/;
        if (reg.test(value)) {
          callback();
        } else {
          return callback(new Error("请输入正确的手机号"));
        }
      }
    };
    return {
      form: {
        account: "",
        name: "",
        job_number: "",
        status: true,
        is_login_app: true,
        password: "",
        phone: "",
        password_confirmation: "",
        roles: [],
        areas: [],
        avatar: "",
        merchant_id:""
      },
      rules: {
        phone: [{ validator: checkPhone, trigger: "blur" }],
        job_number: [
          { min: 3, max: 6, message: "长度在 3 到 6个字符", trigger: "blur" }
        ]
      },
      errors: {},
      roles: [],
      areas: [],
      merchants: [],
      permissions: [],
      merchantsShow: false
    };
  },
  async created() {
    if (this.$store.state.users.user.roles[0] === "administrator") {
      this.merchantsShow = true;
    }
  },
  methods: {
    async onSubmit() {
      console.log(this.form, "form");
      //   this.form.merchant_id=this.form.merchant_id[0]
      if (this.editMode) {
        await updateAdminUser(this.resourceId, this.form);
      } else {
        await storeAdminUser(this.form);
      }
    },
    async getData() {
    
    
      const [{ data: roles }, { data: areas },{ data: merchants }] = await Promise.all([
        getAdminRoles({ all: 1 }),
        getAreas({ all: 1 }),
        getAdminUsersMerchant({ all: 1 })
      ]);

      this.roles = roles;
      this.areas = areas;
        this.merchants = merchants.data;
      console.log(this.areas, "商户");

      const userRoles = _get(store, "state.users.user.roles", []);

      if (userRoles.indexOf(ROLE_ADMIN) !== -1) {
        // 是超级管理员
        this.areas.push({ id: 99999, name: "全部" });
        console.log(this.areas);
      }

      if (this.editMode) {
        const { data } = await editAdminUser(this.resourceId);
        console.log(data, "编辑表格");
        this.fillForm(data);
        if (data.quanbu) {
          this.form.areas.push(99999);
        }
      }
    }
  }
};
</script>
